// //ADD EMPLOYMENT FIELDS TO APPLICATION FORM
// import elements from '../utilities/elements';

// var myElement = document.getElementById("add_more_btn");
// if (myElement) {
//   myElement.addEventListener('click', function (event) {

//     var employment_fields = document.getElementById('employment_fields');

//     let employerNameInputGroup = elements.create.inputGroup('gf_employmentinfo[employer][]', '', '', 'text', '', 'Previous Employer:');
//     let employerAddressInputGroup = elements.create.inputGroup('gf_employmentinfo[address][]', '', '', 'textarea', '', 'Employers Address:');
//     let jobRoleInputGroup = elements.create.inputGroup('gf_employmentinfo[role][]', '', '', 'textarea', '', 'Role:');

//     employment_fields.appendChild(employerNameInputGroup);
//     employment_fields.appendChild(employerAddressInputGroup);
//     employment_fields.appendChild(jobRoleInputGroup);

//   }, false);
// }